// extracted by mini-css-extract-plugin
export default {"modal":"ArchiveJobsModal-module__modal__Q9L95","detail":"ArchiveJobsModal-module__detail__ORU4g"};